import React, { Component, Fragment, useEffect, useState } from "react";
import { usePurchasesDWQuery } from "../../../services/purchasApi";

import Select from "react-select";
import { signInUser } from "../../Utility/Auth";
import customStyles from "./SelectFeild";

const SelectPurchase = ({ handleVendorChange }) => {
  const auth = signInUser();

  const {aamarId} = auth
  
  const [warehouse, setWarehouse] = useState("allWh");

  // let [supplier, setSupplier] = useState([]);
  let [poDw, setPoDw] = useState([]);
  const { data, error, isLoading, isFetching, isSuccess,refetch } =
    usePurchasesDWQuery({warehouse, aamarId});
  // console.log(data);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, [refetch]);

  useEffect(() => {
    refetch();
  }, [warehouse, aamarId]);

  // useEffect(() => {
  //   fetch(`${process.env.REACT_APP_API_URL}supplier`)
  //     .then((res) => res.json())
  //     .then((data) => setSupplier(data));
  // }, []);

  useEffect(() => {
    let poLists = [{ option: "no-poLists", label: "Select PoLists" }];
    if (isSuccess) {
      if (data.length > 0) {
        data?.map((po) => {
          poLists = [
            ...poLists,
            {
              option: po._id,
              label: `${po.poNo} - ${parseFloat(po?.total)?.toFixed(
                2
              )} BDT - [${po.status}]`,
            },
          ];
        });
        setPoDw(poLists);
      }
    }
  }, [data]);
  // console.log(vendor)

  // console.log(vendor.filter((sel) => sel?.option?.toString() === supplier_code?.toString()))

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        value={poDw[poDw.indexOf(poDw)]}
        defaultValue={poDw[0]}
        isDisabled={false}
        isLoading={false}
        isClearable={true}
        // value={
        //   poNo !== ""
        //     ? poDw.filter((sel) => sel?.option?.toString() === poNo?.toString())
        //     : { option: 0, label: "Please Select a Purchase Order" }
        // }
        isSearchable={true}
        name="poNo"
        onChange={handleVendorChange}
        options={poDw}
        styles={customStyles}
      />

      {/* <div
        style={{
          color: "hsl(0, 0%, 40%)",
          display: "inline-block",
          fontSize: 12,
          fontStyle: "italic",
          marginTop: "1em",
        }}
      ></div> */}
    </Fragment>
  );
};

export default SelectPurchase;
